import { render, staticRenderFns } from "./StatsByBusGrp.vue?vue&type=template&id=74658eae&"
import script from "./StatsByBusGrp.vue?vue&type=script&lang=js&"
export * from "./StatsByBusGrp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports